<div class="container bg-container p-1">
  <section id="notLoggedIn">
    <div class="jumbotron mb-3">
      <h1 class="jumbotron-headline" i18n="not-logged-in headline">You're not logged in.</h1>
      <p class="jumbotron-lead">{{message}}</p>
      <button (click)="goToLogin()" color="primary" i18n mat-raised-button>Go to login</button>
    </div>
  </section>
</div>
